import { createContext, useContext, useState, useEffect } from "react";

const API_URL = process.env.REACT_APP_BACKEND_URL;
const ContentContext = createContext({ seoContent: {}, articleHubs: {} });

export const ContentProvider = ({ children }) => {
  const [data, setData] = useState({ seoContent: {}, articleHubs: {} });

  useEffect(() => {
    const load = async () => {
      try {
        const [articlesRes, hubsRes] = await Promise.all([
          fetch(`${API_URL}/api/seo-content`),
          fetch(`${API_URL}/api/content-hubs`),
        ]);

        let seoMap = {};
        let hubsMap = {};

        if (articlesRes.ok) {
          const ad = await articlesRes.json();
          (ad.articles || []).forEach(a => { seoMap[a.slug] = a; });
        }
        if (hubsRes.ok) {
          const hd = await hubsRes.json();
          (hd.hubs || []).forEach(h => {
            const hubId = h.slug.replace("glp-", "");
            hubsMap[hubId] = h;
          });
        }

        setData({ seoContent: seoMap, articleHubs: hubsMap });
      } catch (err) {
        console.error("Failed to load content data", err);
      }
    };
    load();
  }, []);

  return <ContentContext.Provider value={data}>{children}</ContentContext.Provider>;
};

export const useContent = () => useContext(ContentContext);
